import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Подписи ключей `result.skipped` прогона ПЕРЕВОДА (§7.5): `course:{id}`,
 * `lesson:{id}`, `block:{id}`. Свой словарь, а не картиночный и не блочный:
 * у тех другой контракт ключей, и чужая подпись соврала бы про суть пропуска.
 *
 * Незнакомый ключ отдаётся как есть — то же правило, что у `imageTargetLabel`:
 * формат ключей задаёт бэк, и молчаливая пустая строка хуже сырого ключа.
 */
export const translationTargetLabel = (key: string): string => {
  const [kind, id] = key.split(':')
  const m = messagesNow(messages)
  if (kind === 'course') return m.targetCourse
  if (kind === 'lesson' && id) return m.targetLesson(id)
  if (kind === 'block' && id) return m.targetBlock(id)
  return key
}
